/**
 * Note templates — Vague 6.
 *
 * Ready-to-use text snippets the télépro can inject in one click while
 * filling out a note. Keeps the language honest and consistent across
 * télépros so admin recap emails read like the same voice.
 *
 * Each template = { id, label (button), text (inserted) }.
 * When clicked, `text` is either appended to the current draft or (if
 * draft is empty) replaces it entirely.
 */
export const NOTE_TEMPLATES = [
  {
    id: "already_provider",
    label: "Déjà chez concurrent",
    text: "Déjà chez un concurrent, ne souhaite pas changer.",
  },
  {
    id: "call_later_week",
    label: "Rappeler la semaine prochaine",
    text: "Demande à être rappelé la semaine prochaine (préciser jour/heure).",
  },
  {
    id: "closed_wednesday",
    label: "Fermé le mercredi",
    text: "Fermé le mercredi — éviter ce jour pour les rappels.",
  },
  {
    id: "decision_maker_absent",
    label: "Décideur absent",
    text: "Décideur absent — rappeler pour parler à la bonne personne.",
  },
  {
    id: "wants_email_info",
    label: "Demande infos par email",
    text: "Demande à recevoir les infos par email avant de se décider.",
  },
  {
    id: "no_time",
    label: "Pas le temps aujourd'hui",
    text: "Pas dispo aujourd'hui — rappeler à un moment plus calme.",
  },
];
